declare function GetCustomerName();
declare const SITE_URL;

$(function () {
    let $body = $('body');
    let bodyId = $body.attr('id');
    const pageId = 'axelstorenet';

    init();

    if (bodyId === 'Register') {
        pageRegister();
    } else if (bodyId === 'RegisterStep1') {
        RegisterStep1();
    } else if (bodyId === 'MyPage') {
        MyPage();
    } else if (bodyId === 'contact') {
        Contact();
    } else if (bodyId === 'CheckOut') {
        CheckOut();
    } else if(bodyId === 'help') {
        help();
    } else if(bodyId === 'privacy') {
        privacy();
    } else if (bodyId === 'kiyaku') {
        Kiyaku(pageId);
    } else if (bodyId === 'tokutei') {
        Tokutei(pageId);
    }

    // ログイン済の場合、bodyにclassを付与する
    // 入会完了ページではclassを付けない
    if(bodyId != 'fcJoinThk' && GetCustomerName()) {
        $('body').addClass('aem-logined');
    }
});

// プライバシーポリシーのリダイレクト
if (location.href.indexOf('privacy.aspx') != -1) {
    // $('body, html').hide();

    // location.href = 'https://www.axelentermedia.co.jp/privacy/';
}

// 特定のご利用ガイドのURLだったときはサイト側にリダイレクト
const faqTargetUrl = [
    '/v2/help/help05.aspx',
    '/v2/help/help06.aspx',
    '/v2/help/help07.aspx'
]
if (location.href.indexOf(faqTargetUrl[0]) != -1 ||
    location.href.indexOf(faqTargetUrl[1]) != -1 ||
    location.href.indexOf(faqTargetUrl[2]) != -1) {

    $('body, html').hide();

    let hash = '';

    if(location.href.indexOf(faqTargetUrl[0]) != -1) {
        hash = '#about-delivery';
    } else if(location.href.indexOf(faqTargetUrl[1]) != -1) {
        hash = '#cancel-delivery';
    } else if(location.href.indexOf(faqTargetUrl[2]) != -1) {
        hash = '#about-order';
    }

    location.href = `${SITE_URL}faq${hash}`;
}


//　全ページ共通系のリンク先の変更処理
function init() {
    // ヘッダーのお問い合わせのリンク先をサイト側に変更
    $("#cmnhead_button_contact").attr("href", SITE_URL + "faq");
}

// Register
function pageRegister() {
    //$('.tblbody_email .table_control').prepend('<div class="mb-20"><a href="/v2/help/kiyaku.aspx?ccode=' + MODD_CART_ID + '" target="_blank">【利用規約】</a>にご同意の上、メールアドレスを入力してください。</div>');
}

// RegisterStep1
function RegisterStep1() {
    $('.table_label.col_must').each(function(){
        let $title = $(this);

        if($title.text().indexOf('郵便番号') > -1) {
            $title.append('<div class="c-red">※ハイフンなしの半角数字で入力してください。</div>');
        }
    });

    $('.link_autorep').each(function(){
        const $title = $(this);
        if($title.text().indexOf('会員規約') > -1) {
            $title.text('利用規約');
        }
    });
}

// MyPage
function MyPage() {
    // アコーディオンを開いておく
    $('.table_collapse_link').removeClass('collapsed').attr('aria-expanded', 'true');
    $('.glyphicon').removeClass('glyphicon-chevron-left').addClass('glyphicon-chevron-down');
    $('.table_collapse').addClass('in');
}

// Contact
function Contact() {
    $('.t_message').each(function() {
        let $title = $(this);
        if($title.text().indexOf('お電話でのお問い合わせ') > -1) {
            $(this).remove();
        }
    });

    $('#SendNextBtn').val('入力内容を確認する');
}

/**
 * CheckOut：ご注文情報を入力
 *
 **/
function CheckOut() {
    $('.link_autorep').each(function(){
        const $title = $(this);
        if($title.text().indexOf('会員規約') > -1) {
            $title.text('利用規約');
        }
    });
}

/**
 * ご利用ガイド
 */
function help() {

    $('.t_title').text('ヘルプ・ご利用ガイド');

    // 削除対象の見出しリスト
    const delTargetList = [
        '配送について',
        'キャンセル・返品・交換',
        'その他 ご注文について'
    ]

    $('.t_message').each(function () {
        const $title = $(this);
        if(delTargetList.includes($title.text())) {
            // 見出しとその次の要素を削除
            $title.next().remove();
            $title.remove();
        }
    });
}

/**
 * プライバシーポリシー
 */
function privacy() {
    const text ='<span class="bold">【株式会社アクセルエンターメディア】</span>' +
                '<br>' +
                '以下をご確認ください。' +
                '<br>' +
                '<a class="link" href="https://www.axelentermedia.co.jp/privacy/" target="_blank">https://www.axelentermedia.co.jp/privacy/</a>' +
                '<br>' +
                '<br>' +
                '<span class="bold">【株式会社ハンズオン・エンタテインメント アクア】</span>' +
                '<br>' +
                '以下をご確認ください。' +
                '<br>' +
                '<a class="link" href="https://www.handson.gr.jp/privacypolicy/" target="_blank">https://www.handson.gr.jp/privacypolicy/</a>';

    $('#privacyLabel').html(text);
}

// kiyaku
function Kiyaku(pageId) {
  $('#kiyakuLabel').html(`<div style="position:relative;height: 60vh;border: #e4e4e4 solid 1px;"><iframe src="https://docs.axelentermedia.co.jp/kiyaku/${pageId}?textonly" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;padding-top: 10px;" frameborder="0" allowfullscreen></iframe></div>`);
}

// tokutei
function Tokutei(pageId) {
  $('#tokuteiLabel').html(`<div style="position:relative;height: 60vh;border: #e4e4e4 solid 1px;"><iframe src="https://docs.axelentermedia.co.jp/tokutei/${pageId}?textonly" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;padding-top: 10px;" frameborder="0" allowfullscreen></iframe></div>`);
}